import { render } from "./payments-reports-filter.vue?vue&type=template&id=5211e43d"
import script from "./payments-reports-filter.vue?vue&type=script&lang=js"
export * from "./payments-reports-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__